export default {
  email: new RegExp(/.+@.+\..+/i),
  password: new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/),
  lastFour: new RegExp(/^[0-9]{4}$/),
};
